module.exports = __webpack_public_path__ + "static/media/Illus-404@2x.1db8d84a.png";